<template>
    <div class="eval-history">
        <div class="eval-history-wrap">
            <h1>租客所有評價</h1>
            <div class="user-info">
                <span class="title">租客</span>
                <span class="name level1-title-font">
                    <img src="@/assets/img/icon/user_shot_black.svg" alt="">
                    {{tanant}}
                </span>
                <span class="eval">
                    <evaluation v-if="avgRate" :rate="avgRate" starSize="large" ></evaluation>
                </span>
                <span class="count-down">
                    <img src="@/assets/img/icon/timer_gray.svg" alt="">
                    倒數
                    <count-down v-if="countdown" :timeStamp="countdown"></count-down>
                </span>
            </div>
            <div class="eval-table">
                <div class="eval-table-head">
                    <span class="period">租期</span>
                    <span class="name">房東姓名</span>
                    <span class="star">星等</span>
                    <span class="eval-msg">評價內容</span>
                </div>
                <div class="eval-table-body" :key="'height'+componentKey" v-bind:style="{'height': modalHeight}">
                    <ul>
                        <li v-for="(rateItem,index) in historyRateList" :key="index">
                            <span class="period">{{getFormatDate(rateItem.contractBeginTime)}} - {{getFormatDate(rateItem.contractEndTime)}}</span>
                            <span class="name">{{markName(rateItem.landlordName)}}</span>
                            <span class="star"><evaluation :rate="rateItem.rate"></evaluation></span>
                            <span class="eval-msg">{{rateItem.comment}}</span>
                        </li>
                    </ul>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Evaluation from '@/components/widge/Evaluation.vue';
import CountDown from '@/components/widge/CountDown.vue';
import { mapGetters } from 'vuex'
import { 
    apiGetHistoryRate
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            modalHeight: (window.innerHeight-400) + 'px',
            componentKey: 0,
            tanantName: '',
            tanantAvgRate: '',
            // historyRateList: []
        }
    },
    mounted () {
        window.addEventListener('resize', this.resizeModal)
        // this.getHistoryRate()
        // console.log(this.avgRate)
        // console.log(this.historyRateList)
    },
    methods: {
        resizeModal: function (){
            let _self = this
            console.log(window.innerHeight)
            if( window.innerHeight > 610){
                _self.modalHeight = (window.innerHeight-400) + 'px'
                _self.componentKey += 1
            }
        },
        // getHistoryRate: function () {
        //     let data = {
        //         tenantCid: 249,
        //         tenantName: "EddieLandlord"
        //     }

        //     apiGetHistoryRate(data)
        //     .then(res => {
        //         if( res.data.status == "SUCCESS" ){
        //             this.tanantName = res.data.result.tenantName
        //             this.tanantAvgRate = res.data.result.avgRate
        //             this.historyRateList = res.data.result.userRateHistory
        //         }
        //     })
        //     .catch(err => {
        //         reject(err)
        //     })
        // },
        getFormatDate: function (date){
            var formatDate = [];
            var date = new Date(date);
            // var date = new Date(Date.parse(date));
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
            // return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6]+' '+formatDate[3]+':'+formatDate[4];
        }
    },
    computed: {
        ...mapGetters({
            tanant: 'GET_TANANT',
            avgRate: 'GET_AVG_RATE',
            countdown: 'GET_COUNTDOWN',
            historyRateList: 'GET_EVALUATION_LIST',
        })
    },
    components:{
        Evaluation,
        CountDown
    }
}
</script>
<style lang="scss" scoped>
    .eval-history{
        position: relative;
        width: 928px;
        .eval-history-wrap{
            h1{
                font-size: 24px;
                margin-top: 32px;
                margin-bottom: 40px;
                text-align: center;
            }
            .user-info{
                position: relative;
                display: flex;
                align-items: center;
                height: 85px;
                border-radius: 10px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                .title{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 76px;
                    height: 100%;
                    margin-right: 24px;
                    color: #a8a5a4;
                    border-right:1px solid #f1f5f4;
                }
                .name{
                    display: flex;
                    align-items: center;
                    font-weight: 500;
                    margin-right: 18px;
                    img{
                        margin-right: 8px;
                    }
                }
                .eval{
                    position: relative;
                }
                .count-down{
                    position: absolute;
                    display: flex;
                    align-items: center;
                    color: #676362;
                    right: 24px;
                    .countdown{
                        color: #676362;
                    }
                }
            }
            .eval-table{
                margin: 28px 0px 8px 0px;
                .eval-table-head{
                    padding: 20px 30px;
                    border-bottom: 1px solid #f1f5f4;
                    display: flex;
                    > span{
                        display: block;
                        font-size: 12px;
                        font-weight: 300;
                        color: #a8a5a4;
                    }
                }
                .eval-table-body{
                    // height: 534px;
                    overflow-x: hidden;
                    -ms-overflow-style: none;
                    ul{
                        li{
                            position: relative;
                            display: flex;
                            padding: 20px 30px;
                            border-bottom: 1px solid #f1f5f4;
                            align-items: center;
                            > span{
                                display: block;
                            }
                        }
                    }
                }
                .eval-table-body::-webkit-scrollbar {
                    display: none;
                }
                .eval-table-head .period,
                .eval-table-body ul li .period{
                    position: relative;
                    width: 171px;
                    margin-right: 39px;
                }
                .eval-table-head .name,
                .eval-table-body ul li .name{
                    position: relative;
                    width: 50px;
                    margin-right: 58px;
                }
                .eval-table-head .star,
                .eval-table-body ul li .star{
                    position: relative;
                    width: 105px;
                    margin-right: 39px;
                }
                .eval-table-head .eval-msg,
                .eval-table-body ul li .eval-msg{
                    position: relative;
                    width: 400px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/EvalHistory.vue